// import { selectBasketToPay } from 'containers/OrderDetails/basketSlice'
import useTranslation from 'hooks/useTranslation'
// import { displayPrice } from 'utils/string'
import { /* Fragment, */ useState } from 'react'
// import { useSelector } from 'react-redux'
import { toLongDate } from 'utils/date'

const MagSection = ({ identifier, placeId, placeLocks, warehouseLocks, address, termiateDays, size, name, start, end, rangeDate = {} }) => {
  const { street, estateNumber, localNumber, city, province, gpslatitude, gpslongitude } = address || {}
  const { area, internalHeight, internalLength, internalWidth } = size || {}
  const [isExpanded, expand] = useState(false)
  // const toPay = useSelector(selectBasketToPay)

  const { t, lang } = useTranslation('basket')
  // const renderItem = ({ text, price, depositAmount, type }, idx) => {
  //   return <Fragment key={idx}>
  //     <div className={type === 'discount' ? '--red' : undefined}>
  //       <span>{text}: </span>
  //       <span>{displayPrice(depositAmount ? (Number(price) - Number(depositAmount)) : price)}</span>
  //     </div>
  //     {depositAmount && <div className={type === 'discount' ? '--red' : undefined}>
  //       <span>{t('deposit')}: </span>
  //       <span>{displayPrice(depositAmount)}</span>
  //     </div>}
  //   </Fragment>
  // }

  const getRangeString = ({ m = 0, d = 0 }) => {
    if (m < 0) return t('forAnIndefinitePeriod')
    const getDays = () => `${d} ${t(d === 1 ? 'day' : 'days')}`
    const getMonths = () => `${m} ${t(m === 1 ? 'month' : m < 5 ? 'months<5' : 'months>=5')}`
    return !m ? getDays() : `${getMonths()}${d !== 0 ? ` i ${getDays()}` : ''}`
  }

  return (
    <div>
      <div className='list__header element__title'>{t('Warehouse')}</div>
      <div className='list__element --big'>
        <div className='group'>
          <div className='element__title'>{name}</div>
          <i
            className='icon icon--help'
            onClick={() => {
              expand(e => !e)
            }}
          />
        </div>
        <div className={`hidableElement --${isExpanded ? 'visible' : 'hidden'}`}>
          <div className='element__desc'>
            <div>{t('area')}: {Number(area)}m²</div>
            <div>{t('length')}: {internalLength}m</div>
            <div>{t('width')}: {internalWidth}m</div>
            <div>{t('height')}: {internalHeight}m</div>
          </div>
        </div>

        <div className='element__title'>{t('location')}</div>
        <div className='group'>
          <div
            className='element__desc link'
            onClick={() => {
              window.open(`https://www.google.com/maps/search/?api=1&query=${gpslatitude},${gpslongitude}`)
            }}>
            <div>{street} {estateNumber}{localNumber ? `/${localNumber}` : ''}, {t('dist')} {province}, {city}</div>
          </div>
        </div>

        <div className='element__title'>{t('rentalTime')}</div>
        <div className='element__desc'>
          <div>{getRangeString(rangeDate)}</div>
          <div>{toLongDate(start, lang)} → {end ? toLongDate(end, lang) : '∞'}</div>
          <div>{t('noticePeriod')}: {termiateDays} {t('days')}</div>
        </div>

        <div className='element__title'>{t('typesOfOpening')}</div>
        <div className='element__desc'>
          {warehouseLocks && warehouseLocks.length > 0 && <div>
            <span>{t('ofTheWarehouse')}: </span>
            {warehouseLocks.map(({ identifier: id, name }, idx) => <span key={id}>{idx > 0 ? ', ' : ''}{name}</span>)}
          </div>}
          {placeLocks && placeLocks.length > 0 && <div>
            <span>{t('ofTheYard')}: </span>
            {placeLocks.map(({ identifier: id, name }, idx) => <span key={id}>{idx > 0 ? ', ' : ''}{name}</span>)}
          </div>}
        </div>

        {/* <div className='element__title'>{t('costs')}</div>
        {toPay && <div className='element__desc'>
          {toPay[identifier]?.to_pay_without_addons?.list?.map(renderItem)}
          {toPay[identifier]?.to_pay_monthly?.list?.map(renderItem)}
        </div>} */}
      </div>
    </div>
  )
}

export default MagSection